export const SITE_TITLE = 'Inside Wellbeing'
export const DEFAULT_OG_IMAGE = 'https://images.ctfassets.net/mmuao815pexb/7hNOzfqrijgDSq5y1Kf8P6/b738e00794b6f0f05714a3467d102033/opengraph-basic.jpg'
